"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: testapi/tier-testapi-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ftestapi%2Ftier-testapi-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.TierTestApiServiceClient = exports.SubscribeTierResponse = exports.SubscribeTierRequest = exports.AssignTierResponse = exports.AssignTierRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const amount_1 = require("../common/amount");
const tier_testing_service_1 = require("../tier/testing/tier-testing-service");
const tier_type_1 = require("../tier/tier-type");
const protobufPackage = 'com.step.testapi.proto';
function createBaseAssignTierRequest() {
    return { userId: '', tierType: tier_type_1.TierType.INVALID_TIER, expiresAtMs: '0' };
}
exports.AssignTierRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            tierType: isSet(object.tierType) ? (0, tier_type_1.tierTypeFromJSON)(object.tierType) : tier_type_1.TierType.INVALID_TIER,
        };
        if (isSet(object.expiresAtMs)) {
            message.expiresAtMs = globalThis.String(object.expiresAtMs);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.tierType !== tier_type_1.TierType.INVALID_TIER) {
            obj.tierType = (0, tier_type_1.tierTypeToJSON)(message.tierType);
        }
        if (message.expiresAtMs !== undefined && message.expiresAtMs !== '0') {
            obj.expiresAtMs = message.expiresAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.AssignTierRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAssignTierRequest();
        message.userId = object.userId ?? '';
        message.tierType = object.tierType ?? tier_type_1.TierType.INVALID_TIER;
        message.expiresAtMs = object.expiresAtMs ?? '0';
        return message;
    },
};
function createBaseAssignTierResponse() {
    return {};
}
exports.AssignTierResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.AssignTierResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseAssignTierResponse();
        return message;
    },
};
function createBaseSubscribeTierRequest() {
    return { userId: '', tierType: tier_type_1.TierType.INVALID_TIER, amount: amount_1.Amount.fromPartial({}) };
}
exports.SubscribeTierRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            tierType: isSet(object.tierType) ? (0, tier_type_1.tierTypeFromJSON)(object.tierType) : tier_type_1.TierType.INVALID_TIER,
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.tierType !== tier_type_1.TierType.INVALID_TIER) {
            obj.tierType = (0, tier_type_1.tierTypeToJSON)(message.tierType);
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        return obj;
    },
    create(base) {
        return exports.SubscribeTierRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubscribeTierRequest();
        message.userId = object.userId ?? '';
        message.tierType = object.tierType ?? tier_type_1.TierType.INVALID_TIER;
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseSubscribeTierResponse() {
    return {};
}
exports.SubscribeTierResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SubscribeTierResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSubscribeTierResponse();
        return message;
    },
};
/**
 * Tier Testing API Service.
 */
class TierTestApiServiceClient {
    rpc;
    name = 'com.step.testapi.proto.TierTestApiService';
    type = rpc_1.ServiceType.UNAUTHENTICATED;
    path = '/test';
    methods = [{
            name: 'AssignTier',
            requestType: exports.AssignTierRequest,
            responseType: exports.AssignTierResponse,
            authenticationOptions: undefined,
        }, {
            name: 'SubscribeTier',
            requestType: exports.SubscribeTierRequest,
            responseType: exports.SubscribeTierResponse,
            authenticationOptions: undefined,
        }, {
            name: 'SetSubscriptionRenewal',
            requestType: tier_testing_service_1.SetSubscriptionRenewalRequest,
            responseType: tier_testing_service_1.SetSubscriptionRenewalResponse,
            authenticationOptions: undefined,
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Assign a tier to a user.
     */
    assignTier(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Assign a tier to a user.
     */
    subscribeTier(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Set the renewal of a subscription.
     */
    setSubscriptionRenewal(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.TierTestApiServiceClient = TierTestApiServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=tier-testapi-service.js.map